const scrollToTop = (lenis) => {
  if (typeof window === 'undefined') return

  if (lenis) {
    lenis.resize()
    lenis.scrollTo(0, { immediate: true, force: true })
    return
  }

  window.scrollTo(0, 0)
}

export default scrollToTop
